import React, { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  IconButton,
  Tooltip,
  MenuItem,
  TableCell,
  Checkbox,
  TableRow,
  Table,
  TableBody,
  Toolbar,
  TableHead,
  Paper,
  TableContainer,
  TablePagination,
} from "@mui/material";

import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import {
  MAPLOCATION_API_01,
  PARAMETER_API_01,
  PARAMETER_API_02,
  PARAMETER_API_03,
} from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE, CON_STATUS_USER } from "../../utils/sys/Constants";
import { Autocomplete } from "@mui/material";

function SetupParameters() {
  const [data, setData] = useState([]);
    const [datasts, setDatasts] = useState([]);
  const [data1, setData1] = useState([]);
  const [options, setoptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    GROUPNAME: "",
  });
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [rows1, setRows1] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERNAME, USERREFCODE } =
    SYS_USER.USER_PARAM || {};
  const [page, setPage] = useState(0); // Current page number
  const [rowsPerPage, setRowsPerPage] = useState(10); // Number of rows per page
  const paraidToStscodeMap = {
    1: "PARA1", // Example mapping for PARAID 1

    2: "STSYN", // Example mapping for PARAID 2
    3: "PARA1", // Use "PARA1" for PARAID 3
    4: "PARA3", // Example mapping for PARAID 4
    5: "PARA4", // Example mapping for PARAID 5

    10: "STSYN",
    11: "STSYN",
    12: "STSYN",
    13: "STSYN",
    14: "STSYN",
    18: "STSYN",
    20: "STSYN",
    9: "PARA1",
    23: "STSYN",

    // Add more mappings as needed
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(PARAMETER_API_01, "get", {
          COMPCODE,
          LOCCODE: selectedLOC.LOCCODE,
          ALLOWFOR: CON_STATUS_USER,
        });
        setData(result.userparameters);
        setDatasts(result.parameterstatus);
        console.log("Fetched data:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchData();
  }, [selectedLOC.LOCCODE, COMPCODE]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(PARAMETER_API_02, "get");
        setoptions(result);
        console.log("Fetched system status data:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
      }
    };

    fetchData();
  }, []);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  const handleSelectionloc = (newvalue) => {
    setSelectedLOC(newvalue);
    console.log("Selected value:", newvalue);
    // Pass the selected value to any required function here
  };
  useEffect(() => {
    // Initialize formData.parametersDt with data
    setFormData((prevFormData) => ({
      ...prevFormData,
      parametersDt: data.map((row) => ({
        paraid: row.PARAID,
        paravalue: row.PARAVALUE,
      })),
    }));
  }, [data]);

  const handleInputChange = (event, paraid) => {
    const { value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      parametersDt: prevFormData.parametersDt.map((param) =>
        param.paraid === paraid ? { ...param, paravalue: value } : param
      ),
    }));
  };
  const [formData, setFormData] = useState({
    parametersDt: [],
  });

  const handleConfirm = async () => {
    const payload = {
      parametersDt: formData.parametersDt.map((param) => ({
        paraid: String(param.paraid),
        paravalue: param.paravalue,
      })),
      compcode: COMPCODE,
      LOCCODE: selectedLOC.LOCCODE,
      enuser: USERNAME,
      sts: CON_STATUS_ACTIVE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(PARAMETER_API_03, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error:", error);
      // Handle error (e.g., show an error message)
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result); // Populate orderData with the updated array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
    }
  }, [dataloc]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Parameters</Link>
                <Link underline="none">Setup Parameters</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Stack
                sx={styles.AI_fixedStack2}
                direction="row"
                justifyContent="flex-end"
                // spacing={2}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      sx={{ width: 300 }}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Update the state correctly
                  }}
                  value={
                    Array.isArray(dataloc) && dataloc.length > 0
                      ? selectedLOC
                      : null
                  }
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AddStyledBox}>
        <Toolbar
          sx={{
            maxWidth: "100%",
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: {
              xs: "170px",
              md: "135px",
            },
          }}
        >
          <Typography
            variant="h6"
            id="tableTitle"
            component="div"
            sx={{
              ...theme.typography.h2,
              color: theme.palette.text.primary,
              flex: "1 1 100%",
              ml: 1,
            }}
          >
            Setup Parameter
          </Typography>
        </Toolbar>

        <TableContainer
          sx={{
            ...styles.VI_ViewStyledPaper,
            background: theme.palette.background.paper,
            boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    width: "35%",
                    // background: theme.palette.background.paper,
                  }}
                >
                  Parameter
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    width: "20%",
                    // background: theme.palette.background.paper,
                  }}
                  align="left"
                >
                  Data Type
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    width: "45%",
                    // background: theme.palette.background.paper,
                  }}
                  align="left"
                >
                  Value
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.PARAID}>
                  <TableCell align="left">{row.DESCRIPTION}</TableCell>
                  <TableCell align="left">{row.DATATYPE}</TableCell>

                  {/* Dropdown for PARAVALUE */}
                  <TableCell sx={{ maxWidth: "100px" }} align="left">
                    {row.CONTROLLER === 0 ? (
                      <TextField
                        id={`txtbox-${row.PARAID}`}
                        size="small"
                        fullWidth
                        variant="outlined"
                        name={`GROUPNAME-${row.PARAID}`}
                        //value={row.PARAVALUE}
                        value={
                          formData.parametersDt.find(
                            (param) => param.paraid === row.PARAID
                          )?.paravalue || ""
                        }
                        onChange={(e) => handleInputChange(e, row.PARAID)} // Handle value change
                        InputLabelProps={{
                          sx: { ...theme.typography.body2 },
                        }}
                        error={Boolean(errors[row.PARAID])}
                        helperText={errors[row.PARAID]}
                      />
                    ) : (
                      <TextField
                        select
                        id={`txtrate-${row.PARAID}`}
                        size="small"
                        fullWidth
                        variant="outlined"
                        name={`GROUPNAME-${row.PARAID}`}
                        value={
                          formData.parametersDt.find(
                            (param) => param.paraid === row.PARAID
                          )?.paravalue || ""
                        }
                        onChange={(e) => handleInputChange(e, row.PARAID)}
                        InputLabelProps={{
                          sx: { ...theme.typography.body2 },
                        }}
                        error={Boolean(errors[row.PARAID])}
                        helperText={errors[row.PARAID]}
                      >
                      {datasts
  .filter((option) => option.STSCODE === row.STSCODE)
  .map((option) => (
    <MenuItem key={option.STSVALUE} value={option.STSVALUE}>
      {option.DESCRIPTION}
    </MenuItem>
  ))}

                      </TextField>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 50, 100, 500, 1000]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={(props) => (
            <Stack direction="row" spacing={2} alignItems="center">
              {/* Default pagination actions */}
              <div {...props} />

              {/* Custom button */}
              <Button
                sx={{
                  background: theme.palette.primary.main,
                  color: theme.palette.text.buttontxt,
                  textTransform: "capitalize",
                  width: "120px",
                }}
                variant="contained"
                color="primary"
                onClick={handleConfirm}
              >
                Confirm
              </Button>
            </Stack>
          )}
        />

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Parameter Setup Sucessfully
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default SetupParameters;
